import {
  Box,
  Container,
  Tab,
  Tabs,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import variables from "../../../assets/styles/variables.module.scss";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import React, { useState } from "react";
import WorkflowIcon from "@mui/icons-material/AccountTreeOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import { useDispatch } from "react-redux";
import WorkflowsData from "../../Components/Workflows";
import { useLocation } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Workflows = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.only("xs"));

  // Single workflows view only

  return (
    <Container maxWidth="xl" sx={{ py: 3, height: "calc(100vh - 81px)" }}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            background: variables.whiteColor,
            zIndex: 1,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {/* Dynamically updated Breadcrumb */}
          <Breadcrumb data={[{ name: "Workflows", path: "" }]} />

          <Tabs value={0} aria-label="workflows" sx={{ minHeight: { xs: "40px", sm: "68px" }, height: { xs: "40px", sm: "68px" }, mt: { xs: "0", sm: "12px" } }}>
            <Tab icon={<WorkflowIcon />} iconPosition="start" label="Workflow" {...a11yProps(0)} sx={{ minHeight: "32px", height: "32px", textTransform: "capitalize" }} />
          </Tabs>
        </Box>

        <TabPanel value={0} index={0}>
          <WorkflowsData />
        </TabPanel>
      </Box>
    </Container>
  );
};

export default Workflows;
